// extracted by mini-css-extract-plugin
module.exports = {"tabTriggerCard":"TabTriggerCard_tabTriggerCard__7eJWX","icon":"TabTriggerCard_icon__B_odE","label":"TabTriggerCard_label__7DSlw"};